GameView   = require("views/base/game")
Preloader  = require("lib/preload")
Easie      = require("lib/easie")

class GameJeopardyView extends GameView
  templates:
    default: require("./template")
    menu: require("./components/menu")
    question: require("./components/question")

  events: ->
    "iostap .play-game": "enterGame"
    "iostap .goto-next": "next"
    "iostap .btn-question": "showQuestion"
    "iostap .btn-check": "checkAnswer"

  initializeData: ->
    super

    @guesses = []

    @game.extra.set("fullscreen", true)
    @game.extra.set("sounds", true)

    # convert questionId/answerId to id so it works for both normal lesson preview and SCORM without duplicating the logic on those two
    @options.metadata.questions = @options.metadata.questions.map (data) =>
      data.question.id = data.question.questionId || data.question.id
      data.answers = data.answers.map (answer) =>
        answer.id = answer.id || answer.answerId
        answer
      data

    { metadata, data } = @options

    categories = _.chain(metadata.questions)
      .groupBy(({ question }) -> question.category)
      .map((unOrderedQuestions, title) -> { title, unOrderedQuestions })
      .value()

    # Determine format of category questions from data, id/text from metadata
    for category, i in categories
      categories[i].questions = []

      for { mix }, j in data.categories[i]?.questions
        categories[i].questions[j] ?= mix: []
        for q in mix
          categories[i].questions[j].mix.push(categories[i].unOrderedQuestions.shift())

    @questionsDict = _.chain(metadata.questions)
      .pluck('question')
      .indexBy('id')
      .value()
    @answersDict = _.chain(metadata.questions)
      .pluck('answers')
      .flatten()
      .indexBy('id')
      .value()

    @setArray("categories", categories)

  initializeElements: ->
    super

    @setEl @findOne(".game-menu"), "menu"
    @setEl @findOne(".game-question"), "question"

  showNext: (isInitial) ->
    @getEl("menu").innerHTML = @templates.menu
      categories: @getArray("categories")

    @setEl(@getEl("menu").
      querySelectorAll(".btn-question"), "questions")

  showQuestion: (e) ->
    return if @game.timer.get("paused")

    { category, question } = e.currentTarget.dataset

    questions =
      @getArray("categories")[parseInt(category)]
        .questions[parseInt(question)].mix
    randomQuestion = _.sample(questions)
    [trueAnswer, falseAnswer] = _.partition randomQuestion.answers, (a) -> a.content == "true" || a.content == "True"
    [trueAnswer, falseAnswer].map (a) -> a[0].content = a[0].content.toString()

    e.currentTarget.classList.add "question-answered"

    @getEl("question").innerHTML = @templates.question
      question: randomQuestion.question
      answers:
        true: trueAnswer[0]
        false: falseAnswer[0]
      stars: +question + 1

    @getEl("question").offsetLeft

    @el.classList.add("show-question")

  checkAnswer: (e) ->
    el = e.currentTarget
    { questionId, answerId, stars } = el.dataset
    question = @questionsDict[questionId]
    answer = @answersDict[answerId]

    @guesses.push(question, answer)

    return if @game.timer.get("paused") or
              not @el.classList.contains("show-question")

    @el.classList.remove("show-question")

    isCorrect = answer?.correct

    isComplete =
      _.chain(@getEl("questions"))
        .filter((el) ->
          not el.classList.contains("question-answered")
        ).isEmpty()
        .value()

    if isCorrect
      @onCorrectAnswer
        score: 200 * stars
        time:  4000
        tally: true

    if isComplete or not isCorrect
      @endGame()

  answerDetails: ->
    if @options?.metadata?.questions?.length > 0
      @guesses
    else
      []

module.exports = GameJeopardyView
